<template>
  <div class="wrapper">
    <dash-header></dash-header>
    <sidebar></sidebar>
    <div class="content-wrapper p-3">
      <div class="content-header">
        <div class="container-fluid">
          <div class="banner__card">
            <div class="row align-items-center">
              <div class="col-md-8">
                <h2 class="heading">
                  <b>Join</b> and <b>Grow</b><br> with <b>Artrade</b>
                </h2>
                <!-- <template v-if="filterConfig.length>0"> -->
                <button type="button" @click="handleRequest" :disabled="loading || (filterMyib.length>0 && myib.admission_status !== 'REJECTED')" class="btn btn-primary req__btn">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                  <span v-show="!loading">Join Now</span>
                </button>
                <!-- </template> -->
                <!-- <template v-else>
                <p class="color-light">"For more informations, please contact our admin immediately."</p>
                </template> -->
              </div>
              <div class="col-md-4">
                <img src="@/assets/frame_typeib.png" alt="" class="banner__image">
              </div>
            </div>
          </div>

          <div class="my__level">
            <h2 class="title fw-bold" v-if="filterMyib.length>0">Your Level</h2>
            <div class="info__card" v-for="list in filterMyib" :key="list.id">
              <div class="info__image" v-if="list.ib_level == 'INTRODUCING_BROKER'">
                <img src="@/assets/beginner.png" alt="">
              </div>
              <div class="info__image" v-else-if="list.ib_level == 'PARTNER_IB'">
                <img src="@/assets/medium.png" alt="">
              </div>
              <div class="info__image" v-else-if="list.ib_level == 'MASTER_IB'">
                <img src="@/assets/master.png" alt="">
              </div>
              <div class="info__text" v-if="list.ib_level == 'INTRODUCING_BROKER'">
                <span class="badge bg-warning text-dark" v-if="myib.admission_status == 'PENDING'">{{myib.admission_status}}</span>
                <span class="badge bg-success" v-else>{{myib.admission_status}}</span>
                <h2 class="info__heading">
                  Agent
                </h2>
                <!-- <div class="terms">
                  <h2 class="term__value ib">
                    {{list.min_investor}} <span>Users</span>
                  </h2>
                  <h2 class="term__value ib">
                    ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                  </h2>
                </div> -->
              </div>
              <div class="info__text" v-else-if="list.ib_level == 'PARTNER_IB'">
                <h2 class="info__heading">
                  Supervisor Area
                </h2>
                <div class="terms">
                  <h2 class="term__value partner">
                    {{list.min_investor}} <span>Users</span>
                  </h2>
                  <h2 class="term__value partner">
                    ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                  </h2>
                </div>
              </div>
              <div class="info__text" v-else-if="list.ib_level == 'MASTER_IB'">
                <h2 class="info__heading">
                  Manager Area
                </h2>
                <div class="terms">
                  <h2 class="term__value master">
                    {{list.min_investor}} <span>Users</span>
                  </h2>
                  <h2 class="term__value master">
                    ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <h2 class="title fw-bold" v-if="myib.level !== 'MASTER_IB'">Requirements UP Level</h2>
          <template v-if="myib.level !== 'INTRODUCING_BROKER' && myib.level !== 'PARTNER_IB' && myib.level !== 'MASTER_IB'">
          <div class="info__card" v-for="list in investor" :key="list.id">
            <div class="info__image">
              <img src="@/assets/beginner.png" alt="">
            </div>
            <div class="info__text" v-if="list.ib_level == 'INTRODUCING_BROKER'">
              <h2 class="info__heading">
                Agent
              </h2>
              <!-- <div class="terms">
                <h2 class="term__value ib">
                  {{list.min_investor}} <span>Users</span>
                </h2>
                <h2 class="term__value ib">
                  ${{list.min_deposit.toString().substring(0,6)}}
                  <span>Deposit</span>
                </h2>
              </div> -->
            </div>
          </div>
          </template>
          <template v-if="myib.level == 'INTRODUCING_BROKER'">
          <div class="info__card" v-for="list in accountManager" :key="list.id">
            <div class="info__image">
              <img src="@/assets/medium.png" alt="">
            </div>
            <div class="info__text" v-if="list.ib_level == 'PARTNER_IB'">
              <h2 class="info__heading">
                Supervisor Area
              </h2>
              <div class="terms">
                <h2 class="term__value partner">
                  {{list.min_investor}} <span>Users</span>
                </h2>
                <h2 class="term__value partner">
                  ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                </h2>
              </div>
            </div>
          </div>
          </template>
          <template v-if="myib.level == 'PARTNER_IB'">
          <div class="info__card" v-for="list in supervisorArea" :key="list.id">
            <div class="info__image">
              <img src="@/assets/master.png" alt="">
            </div>
            <div class="info__text" v-if="list.ib_level == 'MASTER_IB'">
              <h2 class="info__heading">
                Manager Area
              </h2>
              <div class="terms">
                <h2 class="term__value master">
                  {{list.min_investor}} <span>Users</span>
                </h2>
                <h2 class="term__value master">
                  ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                </h2>
              </div>
            </div>
          </div>
          </template>
          <!-- <div class="info__card" v-for="list in filterConfig" :key="list.id">
            <div class="info__image" v-if="list.ib_level == 'INTRODUCING_BROKER'">
              <img src="@/assets/beginner.png" alt="">
            </div>
            <div class="info__image" v-else-if="list.ib_level == 'PARTNER_IB'">
              <img src="@/assets/medium.png" alt="">
            </div>
            <div class="info__image" v-else-if="list.ib_level == 'MASTER_IB'">
              <img src="@/assets/master.png" alt="">
            </div>
            <div class="info__text" v-if="list.ib_level == 'INTRODUCING_BROKER'">
              <h2 class="info__heading">
                Account Manager
              </h2>
              <div class="terms">
                <h2 class="term__value ib">
                  {{list.min_investor}} <span>Users</span>
                </h2>
                <h2 class="term__value ib">
                  ${{list.min_deposit.toString().substring(0,6)}}
                  <span>Deposit</span>
                </h2>
              </div>
            </div>
            <div class="info__text" v-else-if="list.ib_level == 'PARTNER_IB'">
              <h2 class="info__heading">
                Supervisor Area
              </h2>
              <div class="terms">
                <h2 class="term__value partner">
                  {{list.min_investor}} <span>Users</span>
                </h2>
                <h2 class="term__value partner">
                  ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                </h2>
              </div>
            </div>
            <div class="info__text" v-else-if="list.ib_level == 'MASTER_IB'">
              <h2 class="info__heading">
                Manager Area
              </h2>
              <div class="terms">
                <h2 class="term__value master">
                  {{list.min_investor}} <span>Users</span>
                </h2>
                <h2 class="term__value master">
                  ${{list.min_deposit.toString().substring(0,6)}} <span>Deposit</span>
                </h2>
              </div>
            </div>
          </div> -->
          
        </div>
      </div>
      <section class="content"></section>
    </div>
    <!-- <dash-footer></dash-footer> -->
  </div>
</template>
<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";

import axios from 'axios'
import swal from 'sweetalert'
import $ from 'jquery'

export default {
  name: "Type_IB",
  components: {
    DashHeader,
    // DashFooter,
    Sidebar,
  },
  data(){
    return{
      loading: false,
      delay: false,
      submitted: false,
      myib: [],
      configure: [],
    }
  },
  computed: {
    filterConfig(){
      return this.configure.filter(item => item.ib_level !== this.myib.level)
    },
    investor(){
      return this.configure.filter(item => item.ib_level !== this.myib.level && item.ib_level == 'INTRODUCING_BROKER')
    },
    accountManager(){
      return this.configure.filter(item => item.ib_level !== this.myib.level && item.ib_level == 'PARTNER_IB')
    },
    supervisorArea(){
      return this.configure.filter(item => item.ib_level !== this.myib.level && item.ib_level == 'MASTER_IB')
    },
    filterMyib(){
      return this.configure.filter(item => item.ib_level == this.myib.level)
    }
  },
  async mounted(){
    this.loading = true
    $('[data-widget="treeview"]').Treeview('init');
    this.delay = true
    try {
      await axios.get(`investor/${localStorage.user_id}/ib/requirements/`).then((res)=>{
        this.configure = res.data.data
        this.delay = false
        this.loading = false
      })
      // console.log('Data Config: ', this.configure);
      

      await axios.get(`investor/${localStorage.user_id}/ib/`).then((response)=>{
        this.myib = response.data.data[0]
        this.delay = false
        this.loading = false
      })
      
      // console.log('Data IB: ', this.myib);

      // this.loading = false
    } catch (e) {
      // console.log('Error: ', e.response)
      setTimeout(() => {
        this.delay = false
        this.loading = false
      }, 3000);
      // alert(e.message)
      swal('Oppss!!!', e.message, 'warning', {
        button: "OK"
      })
    }
    
  },
  methods: {
    handleRequest(){
      this.loading = true
      this.submitted = true
      let data = new FormData()
      data.append('investor_id', localStorage.user_id)

      axios.post(`investor/ib/admission/`, data)
      .then((response) => {
        this.loading = false
        // console.log('Resend: ', response);
        swal('Success', response.data.message, 'success', {
          button: "OK"
        }).then(() => {
          this.$router.push('/introduction-broker')
          window.location.reload()
        })

        axios.get(`investor/${localStorage.user_id}/ib/`)
        .then((result) => {
          this.myib = result.data.data[0]
        }).catch(() => {
          // console.log(err.response);
        })
      }).catch((err) => {
        this.loading = false
        // console.log(err.response);
        swal('Sorry,,,,', err.response.data.message, 'error', {
					button: "OK"
				})
      })
    }
  }
};
</script>
<style scoped>
.color-light{
  color: #fff !important;
}
.banner__card{
  background: var(--red);
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 5px 20px rgba(255, 21, 21, 0.3);
  margin-bottom: 30px;
}
.banner__card .heading{
  color: white;
  font-weight: 600;
  text-align: left;
  margin-bottom: 20px;
}
.banner__card .banner__image{
  width: 60%;
  display: block;
  margin: 0 auto;
}
.banner__card .req__btn{
  padding: 15px 40px;
  border-radius: 5px;
}

.info__card{
  border: 1px solid var(--light-grey);
  border-radius: 14px;
  padding: 20px;
  background: white;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.info__card .info__image img{
  width: 100px;
  height: auto;
  margin: 10px;
}
.info__card .info__text{
  margin: 10px;
  padding: 0 30px;
}
.info__card .info__text .info__heading{
  font-weight: 700;
}
.info__card .info__text .terms{
  display: flex;
  align-items: center;
}
.info__card .info__text .terms .term__value{
  margin-right: 30px;
  font-weight: 700;
  font-size: 34pt;
}
.info__card .info__text .terms .term__value.ib{
  color: #ff7667;
}
.info__card .info__text .terms .term__value.partner{
  color: #f7b819;
}
.info__card .info__text .terms .term__value.master{
  color: #00d4ab;
}
.info__card .info__text .terms .term__value span{
  font-weight: 400;
  font-size: 14pt;
  color: var(--darkGrey);
}

.ib-status__card {
  border-radius: 15px;
}
.ib-status__text-card {
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
  font-weight: bold;
  font-size: 20px;
}
.ib-status__numbers {
  font-weight: bold;
  margin-left: 20px;
  font-size: 40px;
}
.ib-status__text-body {
  display: flex;
}
.ib-status__heading {
  font-weight: 600;
  font-size: 30px;
  margin-left: 150px;
  margin-top: -90px;
}
.ib-status__nominal {
  margin-top: -50px;
  margin-left: -428px;
  font-weight: bold;
  font-size: 30px;
}
.dashboard__title {
  color: rgba(0, 0, 0, 0.6);
  font-size: 15px;
  font-weight: 700;
}
.dashboard__card {
  background: #EC0C13 !important;
  border-radius: 15px;
}
.dashboard__heading {
  color: white;
  font-weight: 700;
  font-size: 32px;
  margin-left: 120px;
  text-align: center;
  margin-top: 70px;
}
.dashboard__caption {
  color: white;
  font-size: 20px;
  margin-top: 50px;
  text-align: center;
  font-weight: 600;
  margin-left: 20px;
}
.dashboard__frames {
  width: 230x;
  height: 200px;
  float: right;
  margin-top: -140px;
}
.heading__title {
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
  font-size: 26px;
  margin-left: 7px;
}
.card__advert {
  border-radius: 15px;
}
.card-ib-status {
  border-radius: 15px;
}
.card-ib-status__pcode {
  text-align: center;
  position: relative;
}
.card-ib-status__title {
  text-align: left;
}
.card-ib-status__text-copy {
  font-weight: bold;
  margin-left: 10px;
  text-decoration: none;
  position: absolute;
}

.card-advert__solution {
  font-weight: bold;
  text-align: left;
  margin-left: 140px;
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.card-ib-status__code {
  font-weight: bold;
  position: absolute;
  right: 950px;
  top: 0;
}
.card-advert__button {
  border-radius: 7px;
  font-weight: 500;
  background-color: #2980b9 !important;
  float: right;
  margin-right: 135px;
}
.ib-status__level {
  text-align: right;
  margin-top: -179px;
  font-size: 16px;
}
.ib-status__button-level {
  border-radius: 25px;
  height: 37px;
  width: 120px;
  margin-top: -45px;
  margin-left: 20px;
  font-weight: 500;
}
.my-bonus__level:last-child {
  margin-right: 0px;
}
.my-bonus__level {
  border-radius: 15px;
  display: flex;
  padding-bottom: 15px;
  margin-bottom: -7px;
}
.my-bonus__frames {
  width: 120px;
  height: 120px;
  object-fit: cover;
}
.my-bonus__heading-partner-ib{
  text-align: right;
  font-size: 25px;
  font-weight: 700;
  margin-right: 285px;
  margin-top: -75px;
}
.my-bonus__heading-master-ib{
  text-align: right;
  font-size: 25px;
  font-weight: 700;
  margin-right: 310px;
  margin-top: -75px;
}
.my-bonus__heading-IB{
    text-align: right;
  font-size: 25px;
  font-weight: 700;
  margin-right: 170px;
  margin-top: -75px;
}
.my-bonus__user-count {
  color: #ff7667;
  font-size: 45px;
  text-align: center;
  margin-right: 150px;
  font-weight: 700;
}
.my-bonus__user-caption {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-top: -45px;
  margin-right: 50px;
}
.my-bonus__user-dollars {
  color: #ff7667;
  font-size: 45px;
  text-align: right;
  margin-right: 150px;
  font-weight: 700;
  margin-top: -48px;
}
.my-bonus__user-caption-commision {
  font-size: 20px;
  font-weight: 500;
  text-align: right;
  margin-top: -45px;
  margin-right: 60px;
}
</style>